module.exports = __webpack_public_path__ + "img/female-newborn-figure.43e176e5.svg";